import React, {useEffect, useState} from "react";
import {Modal, Input, Button, Space, Table} from "antd";
import moment from "moment";

export const OrderNoteModal = ({visible, onClose, onOk, order, operationNotes}) => {
    const [note, setNote] = useState("");
    const operationNoteColumns = [
        {
            title: "Not Tarihi",
            dataIndex: "createdAt",
            render: text => moment(text).format("DD.MM.YYYY HH:mm")
        },
        {
            title: "Not",
            dataIndex: "note"
        },
        {
            title: "Aksiyon Alan Kullanıcı",
            dataIndex: "createdBy"
        }
    ];

    useEffect(() => {
        if (visible && order?.operationNote) {
            setNote(order.operationNote);
        } else {
            setNote("");
        }
    }, [visible, order]);

    const handleOk = () => {
        onOk(note);
        setNote("");
    };

    const handleCancel = () => {
        setNote("");
        onClose();
    };

    const handleDelete = () => {
        onOk("");
        setNote("");
    };

    return (
        <Modal
            title="Not"
            visible={visible}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    İptal
                </Button>,
                note ? (
                    <Button key="delete" type="danger" onClick={handleDelete}>
                        Notu Sil
                    </Button>
                ) : null,
                <Button key="submit" type="primary" onClick={handleOk}>
                    Kaydet
                </Button>
            ]}
        >
            <Input.TextArea
                value={note}
                onChange={e => setNote(e.target.value)}
                rows={4}
                placeholder="Not ekleyin..."
            />

            <div style={{marginTop: 20}}>
                <h4>Not Geçmişi</h4>
                <Table
                    dataSource={operationNotes}
                    columns={operationNoteColumns}
                    pagination={false}
                    size="small"
                    scroll={{y: 200}}
                />
            </div>
        </Modal>
    );
};
